import React, { useState } from 'react';
import Singin from './Singin';
import SignUp from './SignUp';
import ForgotPassword from './ForgotPassword';

const AuthModalHandler = ({ 
  show, 
  handleClose, 
  initialMode = 'login',
  onLoginSuccess,
  onSignUpSuccess,
  onForgotPasswordSuccess 
}) => {
  const [currentMode, setCurrentMode] = useState(initialMode);

  const switchToLogin = () => setCurrentMode('login');
  const switchToSignUp = () => setCurrentMode('signup');
  const switchToForgotPassword = () => setCurrentMode('forgot');

  const handleModalClose = () => {
    setCurrentMode('login');
    handleClose();
  };

  const handleLoginSuccess = (response) => {
    // Call parent callback if provided
    if (onLoginSuccess) {
      onLoginSuccess(response);
    }
    
    // Don't close modal immediately - let the component handle closing after showing success message
    // The component will close it via handleClose after the timeout
  };

  const handleSignUpSuccess = (response) => {
    // Call parent callback if provided
    if (onSignUpSuccess) {
      onSignUpSuccess(response);
    }
    // Don't close modal immediately - let the component handle closing after showing success message
    // The component will close it via handleClose after the timeout
  };

  const handleForgotPasswordSuccess = (response) => {
    
    if (onForgotPasswordSuccess) {
      onForgotPasswordSuccess(response);
    }
    
    setCurrentMode('login');
  };

  React.useEffect(() => {
    if (show) {
      setCurrentMode(initialMode);
    }
  }, [show, initialMode]);

  return (
    <>
      <Singin
        show={show && currentMode === 'login'}
        handleClose={handleModalClose}
        switchToSignUp={switchToSignUp}
        switchToForgotPassword={switchToForgotPassword}
        onLoginSuccess={handleLoginSuccess}
      />
      
      <SignUp
        show={show && currentMode === 'signup'}
        handleClose={handleModalClose}
        switchToLogin={switchToLogin}
        onSignUpSuccess={handleSignUpSuccess}
      />
      
      <ForgotPassword
        show={show && currentMode === 'forgot'}
        handleClose={handleModalClose}
        switchToLogin={switchToLogin}
        onForgotPasswordSuccess={handleForgotPasswordSuccess}
      />
    </>
  );
};

export default AuthModalHandler;